import { cn } from '@/lib/utils';
import { CheckCircleIcon, ChevronRightIcon } from 'lucide-react';

interface StepsProps {
  activeStep: number;
}

const items = [
  { title: 'Organisation erstellen' },
  { title: 'Abonnement konfigurieren' },
];

export function ProvisioningSteps({ activeStep }: StepsProps) {
  return (
    <div className="flex items-center">
      {items.map((item, index) => (
        <div
          key={index}
          className="flex items-center justify-between"
        >
          <div
            className={cn(
              'flex w-56 items-center gap-4 rounded-lg border py-2 pr-6 pl-4 transition-colors',
              index === activeStep
                ? 'bg-background'
                : 'bg-card opacity-70 shadow',
            )}
          >
            <div
              className={cn(
                'flex size-8 shrink-0 items-center justify-center rounded-md border text-sm font-semibold',
                index === activeStep
                  ? 'bg-background'
                  : 'bg-active shadow',
              )}
            >
              {index + 1}
            </div>

            <div className="text-base">{item.title}</div>

            {activeStep > index && (
              <CheckCircleIcon className="size-8 text-green-500" />
            )}
          </div>

          {index < items.length - 1 && (
            <ChevronRightIcon className="mx-3" />
          )}
        </div>
      ))}
    </div>
  );
}
